import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tracks page views (load time) and time spent per page.
 * Fires analytics/track on mount and analytics/time on unmount via sendBeacon.
 */
export default function PageAnalytics() {
  const location = useLocation();
  const startRef = useRef(Date.now());
  const pathRef = useRef(location.pathname);

  useEffect(() => {
    const path = location.pathname;
    pathRef.current = path;
    startRef.current = Date.now();

    // Page load time via Navigation Timing API
    let load_ms = null;
    try {
      const entries = performance.getEntriesByType("navigation");
      if (entries.length > 0) {
        const nav = entries[0];
        load_ms = Math.round(nav.loadEventEnd - nav.startTime);
        if (load_ms <= 0) load_ms = null;
      }
    } catch (_) {}

    // Fire page view
    fetch("/api/analytics/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path,
        load_ms,
        referrer: document.referrer || "",
      }),
      keepalive: true,
    }).catch(() => {});

    // On page change or unmount, record time spent on previous page
    return () => {
      const duration_s = (Date.now() - startRef.current) / 1000;
      if (duration_s < 1) return; // ignore bounces < 1s
      const payload = JSON.stringify({ path: pathRef.current, duration_s: Math.round(duration_s) });
      if (navigator.sendBeacon) {
        navigator.sendBeacon("/api/analytics/time", new Blob([payload], { type: "application/json" }));
      } else {
        fetch("/api/analytics/time", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
          keepalive: true,
        }).catch(() => {});
      }
    };
  }, [location.pathname]);

  return null;
}
